import httpManager from "@/app/shared/utils/httpManager";

export async function updatePasswordWork(data) {
  const response = await httpManager.put("/settings/change-password/", data);
  return response.data;
}
